module.exports = __webpack_public_path__ + "static/media/screen-app.93219d02.png";